var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useMemo, useState, useCallback } from 'react';

function useMap(initialValue) {
  var initialMap = useMemo(function () {
    return initialValue === undefined ? new Map() : new Map(initialValue);
  }, []);

  var _a = __read(useState(initialMap), 2),
      map = _a[0],
      setMap = _a[1];

  var stableActions = useMemo(function () {
    return {
      set: function set(key, entry) {
        setMap(function (prev) {
          var temp = new Map(prev);
          temp.set(key, entry);
          return temp;
        });
      },
      setAll: function setAll(newMap) {
        setMap(new Map(newMap));
      },
      remove: function remove(key) {
        setMap(function (prev) {
          var temp = new Map(prev);
          temp["delete"](key);
          return temp;
        });
      },
      reset: function reset() {
        return setMap(initialMap);
      }
    };
  }, [setMap, initialMap]);

  var utils = __assign({
    get: useCallback(function (key) {
      return map.get(key);
    }, [map])
  }, stableActions);

  return [map, utils];
}

export default useMap;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useMap/index.js
// module id = 7498
// module chunks = 2